"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_spring_bottom_sheet_1 = require("react-spring-bottom-sheet");
var Links_1 = __importDefault(require("./Links"));
var Avatar_1 = __importDefault(require("../../Avatar"));
var close_svg_1 = __importDefault(require("../../../../images/close.svg"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var AccountDropdownBottomSheet = function (_a) {
    var _b = _a.displayName, displayName = _b === void 0 ? '' : _b, user = _a.user, open = _a.open, onDismiss = _a.onDismiss;
    return (react_1.default.createElement(react_spring_bottom_sheet_1.BottomSheet, { open: open, onDismiss: onDismiss, snapPoints: function (_a) {
            var minHeight = _a.minHeight;
            return minHeight;
        } },
        react_1.default.createElement("div", null,
            react_1.default.createElement("div", { className: styles_module_scss_1.default.account_dropdown_head },
                react_1.default.createElement("div", { className: styles_module_scss_1.default.close_button, onClick: onDismiss },
                    react_1.default.createElement("img", { src: close_svg_1.default, alt: "close" })),
                react_1.default.createElement(Avatar_1.default, { img: user === null || user === void 0 ? void 0 : user.avatar, name: displayName }),
                react_1.default.createElement("div", { className: styles_module_scss_1.default.account_dropdown_head__info },
                    react_1.default.createElement("div", { className: styles_module_scss_1.default.user_name }, displayName),
                    react_1.default.createElement("span", { className: styles_module_scss_1.default.user_email }, user === null || user === void 0 ? void 0 : user.email))),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.bottom_sheet_menu_section },
                react_1.default.createElement(Links_1.default, { onDismiss: onDismiss })))));
};
exports.default = AccountDropdownBottomSheet;
